export function OutlineFastBackward1Icon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5825 13.4085L14.0006 16.8227L17.5915 20.4144C18.8492 21.666 20.9999 20.7789 20.9999 19.0046V4.99752C20.9999 3.22325 18.8492 2.33132 17.5915 3.58769L14.0006 7.17459L10.5825 10.5888C9.80484 11.3705 9.80484 12.6316 10.5825 13.4085Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.58328 13.4085L10.5922 20.4144C11.85 21.666 14.0006 20.7789 14.0006 19.0046V16.8227L10.5826 13.4085C9.80489 12.6316 9.80489 11.3705 10.5826 10.5888L14.0006 7.17459V4.99752C14.0006 3.22325 11.85 2.33132 10.5922 3.58769L3.58328 10.5888C2.80557 11.3705 2.80557 12.6316 3.58328 13.4085Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.00244 3.00781V20.9902"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
